import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ReactECharts from "echarts-for-react";
import { getDuckyByRegion } from "../../selectors/widget.js";
import Block from "../Block";
import { round } from "lodash";

const Graph = ({ module }) => {
  const { cityIndex, county } = module;
  const [mergedOptions, setMergedOptions] = useState(null);

  const [leftDropDownOptions, setLeftDropDownOptions] = useState(null);
  const [selectedLeftValue, setSelectedLeftValue] = useState(null);
  const [selectedType, setSelectedType] = useState({ label: "Generel", value: "general" });
  const [typeOptions] = useState([
    { label: "Generel", value: "general" },
    { label: "Mat og drikke", value: "food" },
  ]);

  const [apiDataset, setApiDataset] = useState(null);
  const [filteredDataset, setFilteredDataset] = useState(null);
  const apiResult = useSelector((state) => getDuckyByRegion(state, "Sørøst"));

  useEffect(() => {
    if (apiResult && selectedType) {
      let apiResultData = apiResult.filter((x) => x.type === selectedType.value);
      setApiDataset(apiResultData[0].data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiResult, selectedType]);
  useEffect(() => {
    if (apiDataset) {
      let filtered = apiDataset.filter((item) => item.areaId === "0" || item.areaId === cityIndex.toString());
      setFilteredDataset(filtered);
    }
  }, [apiDataset, cityIndex]);

  useEffect(() => {
    if (apiDataset) {
      let filtered = apiDataset.filter((item) => item.areaId !== "0" && item.areaId !== cityIndex.toString());
      const unique = [...new Set(filtered.map((item) => item))];
      let sorted = unique.sort((a, b) => (a.name > b.name ? 1 : -1));
      let parsed = parseOptions(sorted);
      setLeftDropDownOptions(parsed);
    }
  }, [apiDataset, cityIndex]);

  useEffect(() => {
    if (selectedLeftValue && apiDataset) {
      const filterPeriod = (place) => {
        let filtered = apiDataset.filter((item) => item.areaId === cityIndex.toString());

        setFilteredDataset(filtered);
      };
      filterPeriod(selectedLeftValue.value);
    }
  }, [selectedLeftValue, apiDataset, cityIndex]);

  useEffect(() => {
    if (leftDropDownOptions && !selectedLeftValue) {
      setSelectedLeftValue(leftDropDownOptions.filter((item) => item.value === county)[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leftDropDownOptions, selectedLeftValue]);
  useEffect(() => {
    if (!selectedType && typeOptions && apiDataset) {
      setSelectedType(typeOptions[0]);
    }
  }, [selectedType, typeOptions, apiDataset]);

  useEffect(() => {
    if (filteredDataset) {
      let data = filteredDataset;
      let translate = {
        food: "Mat",
        transport: "Transport",
        consumption: "Varer & tjenester",
        energy: "Energi",
        public: "Offentlig",
        grains: "Korn",
        meat: "Kjøtt",
        fish: "Fisk",
        dairyAndEggs: "Meieriprodukter og egg",
        produce: "Grønnsaker",
        beverages: "Drikkevarer",
      };
      let seriesData = data.map((item) => {
        let obj = {
          name: item.name,
          radius: "75%",
          type: "pie",
          data: Object.entries(item.categories).map(([key, value]) => ({
            name: translate[key],
            value: round(value.co2Kg / 1000, 2),
            total: round((value.co2Kg * item.population) / 1000),
          })),
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        };
        return obj;
      });
      let nObj = {
        ...JSON.parse(options),
        title: {
          text: `Totalt utslipp: ${round((data[0].totalCo2Kg * data[0].population) / 1000, 0).toLocaleString(
            "nb-NO"
          )} tonn CO₂e`,
          left: "center",
          top: "bottom",
          textStyle: {
            fontWeight: "bolder",
            fontSize: 16,
          },
        },
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            let tooltip = `${params.name} (${params.percent.toLocaleString("nb-NO")}%) <br/>`;
            tooltip += `${params.marker} ${params.data.total.toLocaleString("nb-NO") + " tonn CO₂e"} </br>`;
            return tooltip;
          },
        },
        label: {
          show: true,
          formatter: function (params) {
            return `${params.name} (${params.percent.toLocaleString("nb-NO")}%)`;
          },
        },
        legend: {
          orient: "vertical",
          left: "left",
        },

        series: seriesData,
      };

      setMergedOptions(nObj);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredDataset, selectedLeftValue]);

  if (mergedOptions) {
    return (
      <Block>
        <ReactECharts option={mergedOptions} style={{ marginTop: "20px", height: "300px" }} notMerge={true} />
      </Block>
    );
  }

  return null;
};
export default Graph;

const options = JSON.stringify({
  grid: { top: 40, right: 10, bottom: 2, left: 10, containLabel: true },
});

const parseOptions = (options) => {
  return options.map((option) => Object.assign({}, { label: option.name, value: option.areaId }));
};
